import React, { useState, useEffect, createContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';
import Fighters from './pages/Fighters';
import Auth from './pages/Auth';
import Home from './pages/Home';
import About from './pages/About';
import Meme from './pages/Meme';
import Admin from './pages/Admin';

// Create auth context to share authentication state
export const AuthContext = createContext(null);

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const isLoggedIn = !!token;

  // Clone the children element and pass the authentication status
  return React.cloneElement(children, { isLoggedIn });
};

// Admin Route wrapper component
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!token) {
    return <Navigate to="/auth" />;
  }

  if (user.id !== 1) {
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Update authentication state when token changes
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    setIsAuthenticated(!!token);
    setIsAdmin(user.id === 1);

    // Listen for storage events (in case of logout in another tab)
    const handleStorageChange = () => {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      setIsAuthenticated(!!token);
      setIsAdmin(user.id === 1);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setIsAdmin(false);
    window.location.href = '/auth';
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, isAdmin, setIsAdmin }}>
      <Router>
        <div className="App">
          <nav className="navbar">
            <div className="nav-links">
              <img src="/logo512.png" alt="Website Logo" style={{ height: '20px', marginRight: '20px' }} />
              <Link to="/">HOME</Link>
              {isAdmin && <Link to="/bot">BOT</Link>}
              <Link to="/fighters">FIGHTERS</Link>
              <Link to="/meme">MEME CREATOR</Link>
              {isAdmin && <Link to="/admin">ADMIN</Link>}
            </div>
            <div className="nav-auth">
              <Link to="/about">ABOUT</Link>
              {isAuthenticated ? (
                <a href="#" onClick={handleLogout}>LOGOUT</a>
              ) : (
                <Link to="/auth">LOGIN</Link>
              )}
            </div>
          </nav>

          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/bot" element={
              <AdminRoute>
                <Bot />
              </AdminRoute>
            } />
            <Route path="/meme" element={
              <ProtectedRoute>
                <Meme />
              </ProtectedRoute>
            } />
            <Route path="/fighters" element={
              <ProtectedRoute>
                <Fighters />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            } />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

// Placeholder components
const Bot = () => <div>Bot Page</div>;

export default App;
